import {
  MINDCLOUD_BRIDGE_EVENTS,
  subscribeParentMessages,
  isParentBridgeAvailable,
} from '@/services/parentBridge';
import { useViewerStore, type UnitSystem } from '@/stores/viewerStore';

function isValidUnitSystem(value: unknown): value is UnitSystem {
  return value === 'metric' || value === 'imperial';
}

/**
 * 监听父页面单位制切换，同步到 viewerStore
 */
export function initHostUnitSystemSync(): void {
  if (!isParentBridgeAvailable()) return;

  subscribeParentMessages((message) => {
    if (message.type !== MINDCLOUD_BRIDGE_EVENTS.hostUnitSystemChange) return;
    const payload = message.payload as { unitSystem?: unknown } | undefined;
    const unitSystem = payload?.unitSystem;
    if (isValidUnitSystem(unitSystem)) {
      useViewerStore.getState().setUnitSystem(unitSystem);
    }
  });
}
